import { Helmet } from 'react-helmet-async';

// エラー画面はHTTPステータス200のままクライアント側でDOMに描画されるため、
// クロール時に「500 Internal Server Error」等の文言がインデックスされてしまう(STAR-4367)。
// エラー描画時のみ noindex を動的注入し、検索結果への焼き付きを防ぐ。
export default function NoindexHelmet() {
  return (
    <Helmet>
      <meta
        name='robots'
        content='noindex, nofollow'
      />
    </Helmet>
  );
}
